(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["form-asesoria"]) return;
  try {
    
$(function() {
	console.log("from asesoria");
	$(document).on('change', '#subject', function(){
		console.log($(this).val());
		if($(this).val() == "Otro"){
			$("#other_subject").show();
			$("#other_subject").addClass("required");
		} else {
			$("#other_subject").hide();
			$("#other_subject").removeClass("required");
		}
	});

	$(document).on('click', '#send', function(){
		console.log('Enviando');

		var isValid = validateFrm("#contact_form_asesoria .required");
		
		if(isValid){
          var subject = $("#subject").val() != 'Otro'? $("#subject").val(): $("#other_subject").val();
		  var body = '';

		  $('#contact_form_asesoria .fld').each(function(){
			  if($(this).css('display') != 'none'){
                var name = $(this).attr('data-name');
                var val = $(this).val();

                body += name + ": " + val + "<br>";
			  }

          });
		  
          var wrapper = {
            group_id: $("#group_id").val(),
            subject: subject,
            contact_email: $("#email").val(),
            contact_name: $("#fullname").val() + ' ' + $("#lastname").val(),
			body: body
          };

          console.log(wrapper);
		  
          $.ajax({
            url: "http://mrclick.azurewebsites.net/api/wcx",
            type: "POST",
            data: JSON.stringify(wrapper),
            contentType: "application/json;charset=utf-8",
            success: function (data) {
              if (data != null ) {
                console.log("resultado wcx");
                console.log(data);
				var json = JSON.parse(data);
                clear('#contact_form_asesoria input');
                clear('#contact_form_asesoria textarea');
                clearSelect('#contact_form_asesoria select');
                Swal.fire({
                  icon: 'success',
                  title: 'Muchas gracias, tu caso ha sido creado',
                  text: 'Tu solicitud será enviada a nuestros agentes de servicio y serás contactado a la brevedad posible. Gracias por preferirnos. Mr Click.',
                  showConfirmButton: true
                })

              }
              else {
                alert("Error creación");
                //$("#"+id+"Loading").hide();
                //$("#"+id).show();
              }

          },
          error: function (msg) {
            
            var responseText = msg.responseText;
            
			Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: errorMsg 
            })
          }
        });
			

		  
		}
	});
});  

function validateFrm(selector){
  	var isValid = true;
    
    $(selector).each(function(){
    	var val = $(this).val();
      
        if(val == null || val.length == 0 || val == 'Seleccione'){
			isValid = false;
          	$(this).addClass("input--error");
        } else {
        	$(this).removeClass("input--error");
        }
	});
    
    return isValid;
}

function clear(selector){
	$(selector).each(function(){
    	//var val = $(this).val();
      
        $(this).val("");
	});
}

function clearSelect(selector){
	$(selector).each(function(){
    	//var val = $(this).val();
      
        $(this).val("Seleccione");
	});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form-dudas"]) return;
  try {
    
$(function() {
	console.log("from asesoria");
	$(document).on('change', '#subject', function(){
		console.log($(this).val());
		toggleField("#other_subject", false);
		toggleField("#rut", false);
		toggleField("#razon_social", false);
		toggleField("#giro", false);
		toggleField("#direccion_empresa", false);
		toggleField("#calle", false);
        toggleField("#comuna", false);
        toggleField("#region", false);
		toggleField("#fecha_hora", false);
		
		$("#note").html("");
		$("#note").hide();

		var selected_value = $(this).val();
		if(selected_value == "Otro"){
			toggleField("#other_subject", true);
		} else if(selected_value == "Solicito factura / cambio boleta por factura") {
			toggleField("#rut", true);
			toggleField("#razon_social", true);
			toggleField("#giro", true);
			toggleField("#direccion_empresa", true);
			
		} else if(selected_value == "Cambio dirección de envío") {
			toggleField("#calle", true);
			toggleField("#comuna", true);
			toggleField("#region", true);

			$("#note").html("* Solo se puede cambiar la dirección si el pedido no ha sido despachado.");
			$("#note").show();
			
		} else if(selected_value == "Retiro en tienda"){
			toggleField("#rut", true);
			toggleField("#fecha_hora", true);
			$("#note").html("* Dirección bodega: Camino Lo Boza 107, bodega B24, horario de lunes a viernes de 8:30 a 15:30 hrs");
			$("#note").show();
		}
	});

	$(document).on('click', '#send', function(e){
		console.log('Enviando');

		var isValid = validateFrm("#contact_form_asesoria .required");
		
		if(!isValid){
			e.preventDefault();
			return;
		}

        var subject = $("#subject").val() != 'Otro'? $("#subject").val(): $("#other_subject").val();
		var body = '';

		$('#contact_form_asesoria .fld').each(function(){
			if($(this).css('display') != 'none'){
                var name = $(this).attr('data-name');
                var val = $(this).val();

                body += name + ": " + val + "<br>";
			}

        });

		$("#contact_name_combined").val($("#fullname").val() + ' ' + $("#lastname").val());
		$("#contact_subject_combined").val(subject);
		$("#contact_body_combined").val(body);

		// se deja que el formulario haga un submit nativo a /contact
		// (Shopify gestiona la protección anti-spam/CAPTCHA automáticamente solo
		// cuando el envío es un submit real del <form>, no vía AJAX manual).
	});

	if (window.__mrclick_dudas_success) {
		clear('#contact_form_asesoria input');
		clear('#contact_form_asesoria textarea');
		clearSelect('#contact_form_asesoria select');
		Swal.fire({
		  icon: 'success',
		  title: 'Muchas gracias, tu caso ha sido creado',
		  text: 'Tu solicitud será enviada a nuestros agentes de servicio y serás contactado a la brevedad posible. Gracias por preferirnos. Mr Click.',
		  showConfirmButton: true
		});
	}
	if (window.__mrclick_dudas_error) {
		Swal.fire({
		  icon: 'error',
		  title: 'Oops...',
		  text: 'Hubo un problema al enviar tu solicitud. Por favor intenta nuevamente o contáctanos directamente.'
		});
	}
});  

function validateFrm(selector){
  	var isValid = true;
    
    $(selector).each(function(){
    	var val = $(this).val();
      
        if(val == null || val.length == 0 || val == 'Seleccione'){
			isValid = false;
          	$(this).addClass("input--error");
        } else {
        	$(this).removeClass("input--error");
        }
	});
    
    return isValid;
}

function clear(selector){
	$(selector).each(function(){
    	//var val = $(this).val();
      
        $(this).val("");
	});
}

function clearSelect(selector){
	$(selector).each(function(){
    	//var val = $(this).val();
      
        $(this).val("Seleccione");
	});
}

function toggleField(selector, show){
	if(show){
		$(selector).show();
	    $(selector).addClass("required");
	} else {
		$(selector).hide();
	    $(selector).removeClass("required");
	}
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form-soporte"]) return;
  try {
    
$(function() {
	console.log("from asesoria");

	$(document).on('change', '#subject', function(){
		console.log($(this).val());
		toggleField("#tipo_problema", false);
		toggleField("#tipo_devolucion", false);
		toggleField("#other_problem", false);
		toggleField("#fecha_hora", false);
		toggleField("#rut", false);

		$("#note").html("");
		$("#note").hide();
		$("#note2").html("");
		$("#note2").hide();

		var selected_value = $(this).val();
		if(selected_value == "Otro"){
			toggleField("#other_subject", true);
		} else if(selected_value == "Quiero ejercer mi garantía legal por falla de fabrica") {
			toggleField("#tipo_problema", true);

			$("#note").html("* Recuerda que por falla de fábrica la garantía cubre hasta 6 meses luego de haber recibido tu producto.");
			$("#note").show();

		} else if(selected_value == "Quiero devolver mi producto por disconformidad (retracto)") {
			toggleField("#tipo_devolucion", true);

			$("#note").html("* Recuerda que tienes 10 días desde recibir el producto y este debe venir con su empaque original, boleta, y todos los accesorios/componentes, tal como se entregó. ¿Qué procede? Debes hacer llegar el producto a nuestra dependencia ubicada en Camino Lo Boza 107, bodega B24. Si eres de región debes enviar el producto vía Starken (envío pagado) a la misma dirección. Si vienes de manera presencial a entregar el producto debes indicar fecha y hora para registrarte y puedas ingresar a nuestra bodega.");
			$("#note").show();

		} else if(selected_value == "Retiro en tienda"){
			toggleField("#fecha_hora", true);
			$("#note").html("* Dirección bodega: Camino Lo Boza 107, bodega B24, horario de lunes a viernes de 9:00 a 16:00 hrs");
			$("#note").show();
		}
	});

	$(document).on('change', '#tipo_problema', function(){
		toggleField("#other_problem", false);
		var selected_value = $(this).val();

		if(selected_value == "Otro"){
			toggleField("#other_problem", true);
		}
	});

	$(document).on('change', '#tipo_devolucion', function(){
		toggleField("#fecha_hora", false);
		toggleField("#rut", false);
		$("#note2").html("");
		$("#note2").hide();
		var selected_value = $(this).val();

		if(selected_value == "Enviaré el producto"){
			$("#note2").html("* Debes enviar el producto vía Starken a nuestra dependencia ubicada en Camino Lo Boza 107, Pudahuel. Bodega B24 dirigido a Andrea Romero RUT 76.975.635-3. El producto debe venir resguardado con todos sus componentes, luego de pasar por mesa técnica se le dará resolución a tu solicitud. Si está todo en orden la devolución tarda hasta 5 días hábiles.");
			$("#note2").show();
		} else {
			toggleField("#rut", true);
			toggleField("#fecha_hora", true);
			$("#note2").html("* Horario de lunes a viernes de 8:30 a 15:30 hrs");
			$("#note2").show();
		}
	});

	$(document).on('click', '#send', function(e){
		console.log('Enviando');

		var isValid = validateFrm("#contact_form_asesoria .required");

		if(!isValid){
			e.preventDefault();
			return;
		}

		var subject = $("#subject").val() != 'Otro'? $("#subject").val(): $("#other_subject").val();
		var body = '';

		$('#contact_form_asesoria .fld').each(function(){
			if($(this).css('display') != 'none'){
				var name = $(this).attr('data-name');
				var val = $(this).val();

				body += name + ": " + val + "<br>";
			}
		});

		$("#contact_name_combined").val($("#fullname").val() + ' ' + $("#lastname").val());
		$("#contact_subject_combined").val(subject);
		$("#contact_body_combined").val(body);

		// se deja que el formulario haga un submit nativo a /contact
		// (Shopify gestiona la protección anti-spam/CAPTCHA automáticamente solo
		// cuando el envío es un submit real del <form>, no vía AJAX manual).
	});

	if (window.__mrclick_soporte_success) {
		clear('#contact_form_asesoria input');
		clear('#contact_form_asesoria textarea');
		clearSelect('#contact_form_asesoria select');
		Swal.fire({
		  icon: 'success',
		  title: 'Muchas gracias, tu caso ha sido creado',
		  text: 'Tu solicitud será enviada a nuestros agentes de servicio y serás contactado a la brevedad posible. Gracias por preferirnos. Mr Click.',
		  showConfirmButton: true
		});
	}
	if (window.__mrclick_soporte_error) {
		Swal.fire({
		  icon: 'error',
		  title: 'Oops...',
		  text: 'Hubo un problema al enviar tu solicitud. Por favor intenta nuevamente o contáctanos directamente.'
		});
	}
});

function validateFrm(selector){
  	var isValid = true;

    $(selector).each(function(){
    	var val = $(this).val();

        if(val == null || val.length == 0 || val == 'Seleccione'){
			isValid = false;
          	$(this).addClass("input--error");
        } else {
        	$(this).removeClass("input--error");
        }
	});

    return isValid;
}

function clear(selector){
	$(selector).each(function(){
    	//var val = $(this).val();

        $(this).val("");
	});
}

function clearSelect(selector){
	$(selector).each(function(){
    	//var val = $(this).val();

        $(this).val("Seleccione");
	});
}

function toggleField(selector, show){
	if(show){
		$(selector).show();
	    $(selector).addClass("required");
	} else {
		$(selector).hide();
	    $(selector).removeClass("required");
	}
}

  } catch(e) { console.error(e); }
})();
})();
